export const theme = {
  blue: "#001e82",
  red: "#b30000",
  mobileSize: "500px",
}
